export type CounterpartySide = 'debit' | 'credit';

export function resolveCounterpartySide(debit: number, credit: number): CounterpartySide | null {
  const d = Number(debit || 0);
  const c = Number(credit || 0);
  if (d > 0 && c <= 0) return 'debit';
  if (c > 0 && d <= 0) return 'credit';
  return null;
}

export function counterpartySideLabelFa(side: CounterpartySide | null | undefined): string {
  if (side === 'debit') return 'بدهکار';
  if (side === 'credit') return 'بستانکار';
  return '—';
}

export function counterpartyKeyFromRow(
  type: string | null | undefined,
  id: number | null | undefined,
): string {
  if (!type || id == null || id <= 0) return '';
  const t = String(type).trim().toLowerCase();
  if (t !== 'employee' && t !== 'client' && t !== 'company') return '';
  return `${t}-${id}`;
}
